import React from 'react';
import {OrbitComponent} from "../../../../../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {DenmarkSelfExclusionButtonBox} from "./boxes/denmark.self-exclusion-button.box";
import {CyClass} from "../../../../../../../common/cy-classes";

export const DenmarkSelfExclusionButtonComponent = observer(class DenmarkSelfExclusionButtonComponent extends OrbitComponent {
    private _clickHandler = async () => {
        this.services.analytics.sendOrbitUserFlowEvent("Navigation","Header", 'Icon_dk_stop_spillet_icon_click');
        await this.services.linksNavigation.openSelfExclusion();
    }
    render() {
        return (
            <DenmarkSelfExclusionButtonBox imageUrl={this.services.theme.currentTheme.assets.images.regulation_specific.denmark.self_exclusion_png.toString()}
                                           onClick={this._clickHandler}
                                           className={CyClass('cy-dk-stop-spillen-icon')}/>
        )
    }
});